export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/af13f5585baf787e768f29c2c941beba.png";